import { HashSet2dzve9y63nf0v as HashSet } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/HashSet.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function identitySet(expectedSize) {
  return HashSet().j3(expectedSize);
}
//region block: exports
export {
  identitySet as identitySet1lu9dl60optk8,
};
//endregion

//# sourceMappingURL=Concurrent.mjs.map
